import React from 'react';
import ReactSlider from 'react-slider';
import styled from 'styled-components';
import { formatPrice } from '../../utils';

interface IPriceSliderProps {
  priceDeltas: [number, number];
  priceValues: [number, number];
  setPriceValues(values: [number, number]): void;
}

const PriceSlider: React.FC<IPriceSliderProps> = ({
  priceDeltas,
  priceValues,
  setPriceValues,
}) => (
  <PriceSliderContainer>
    <StyledReactSlider
      thumbClassName="thumb"
      trackClassName="track"
      value={priceValues}
      ariaLabel={['Lower thumb', 'Upper thumb']}
      ariaValuetext={(state) => `Thumb value ${state.valueNow}`}
      renderThumb={(props) => <div {...props} />}
      step={priceDeltas[1] < 1000 ? 100 : 1000}
      minDistance={priceDeltas[1] < 1000 ? 100 : 1000}
      min={priceDeltas[0]}
      max={priceDeltas[1]}
      onChange={setPriceValues}
    />
    <PriceValuesContainer>
      <span>{formatPrice(priceValues[0])}</span>
      <span>{formatPrice(priceValues[1])}</span>
    </PriceValuesContainer>
  </PriceSliderContainer>
);

const PriceSliderContainer = styled.div`
  margin-bottom: 26px;
`;

const StyledReactSlider = styled(ReactSlider)`
  position: relative;
  z-index: 0;
  .thumb {
    background: ${(props) => props.theme.colors.primary};
    height: 14px;
    width: 14px;
    border-radius: 100%;
    transform: translateY(-40%);
  }
  .track {
    background-color: ${(props) => props.theme.colors.primary};
    height: 3px;
    &.track-0,
    &.track-2 {
      background-color: #d6d6d6;
    }
  }
`;

const PriceValuesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    font-size: 12px;
    line-height: 14px;
    margin-top: 14px;
    font-weight: bold;
    font-family: ${(props) => props.theme.fonts.helvetica};
    color: ${(props) => props.theme.colors.dark.secondary};
  }
`;

export default React.memo(PriceSlider);
